/* BVA "Komplettera ditt set" — wires the PDP block to the shared compatibility
   rules and the Cart AJAX API. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var ROLLNAMN = {
    cylinder: 'Cylinder', pump: 'Pump', hose: 'Hydraulslang',
    coupling: 'Snabbkoppling', gauge: 'Manometer',
    gauge_adapter: 'Manometeradapter', oil: 'Hydraulolja'
  };

  function kr(ore) {
    return (Math.round(ore / 100)).toLocaleString('sv-SE').replace(/ | /g, ' ') + ' kr';
  }

  function las(rot, valjare) {
    var el = rot.querySelector(valjare);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function init(rot) {
    if (rot.__bva) return;
    rot.__bva = true;
    var spara = window.vpSpara || function () {};

    var cylinder = las(rot, '[data-bva-cylinder]');
    var pumpar = las(rot, '[data-bva-pumps]') || [];
    var delar = las(rot, '[data-bva-parts]') || {};
    var lista = rot.querySelector('[data-bva-list]');
    var kropp = rot.querySelector('[data-bva-body]');
    if (!cylinder || !lista) return;

    var passande = window.BVACompat.matchingPumps(cylinder, pumpar.filter(function (p) { return p.available; }));
    var behov = window.BVACompat.oilRequired(cylinder);
    var krav = window.BVACompat.requiredPumpCapacity(cylinder);
    var antalKretsar = window.BVACompat.circuitCount(cylinder);

    if (!passande.length) {
      kropp.innerHTML = '<div class="bva-tom">Den här cylindern kräver en pump med minst <strong>' +
        (krav || '—') + ' cm³</strong> oljevolym, vilket är mer än våra lagerförda pumpar rymmer. ' +
        '<a href="/pages/offert">Kontakta oss så tar vi fram rätt lösning</a>.</div>';
      return;
    }

    var vald = { pump: passande[0] };
    ['hose', 'coupling', 'gauge', 'gauge_adapter', 'oil'].forEach(function (r) {
      if (delar[r]) vald[r] = delar[r];
    });
    var pa = { pump: true, hose: true, coupling: true, gauge: true, gauge_adapter: true, oil: true };

    function rad(roll, produkt, antal, extraHtml) {
      var av = pa[roll] ? '' : ' is-off';
      return '<div class="bva-row' + av + '" data-roll="' + roll + '">' +
        '<input type="checkbox" class="bva-check" data-bva-toggle="' + roll + '"' + (pa[roll] ? ' checked' : '') + ' aria-label="Ta med ' + (ROLLNAMN[roll] || roll) + '">' +
        '<span class="bva-thumb">' + (produkt.image ? '<img src="' + produkt.image + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="bva-body">' +
          '<span class="bva-role">' + (ROLLNAMN[roll] || roll) + (antal > 1 ? ' × ' + antal : '') + '</span>' +
          '<a class="bva-name" href="' + produkt.url + '">' + produkt.title + '</a>' +
          (extraHtml || '') +
        '</span>' +
        '<span class="bva-price">' + kr(produkt.price * antal) + '</span>' +
      '</div>';
    }

    function rita() {
      var html = '';

      var pumpVal = '<select class="bva-pumpval" data-bva-pumpval>' + passande.map(function (p) {
        return '<option value="' + p.handle + '"' + (p.handle === vald.pump.handle ? ' selected' : '') + '>' +
          p.title + ' — ' + p.oil_capacity_cm3 + ' cm³ — ' + kr(p.price) + '</option>';
      }).join('') + '</select>';
      var pumpInfo = '<span class="bva-meta">Cylindern behöver ' + (behov || '—') + ' cm³' +
        (krav ? ', pumpen måste rymma minst ' + krav + ' cm³' : '') + '</span>' + pumpVal;
      html += rad('pump', vald.pump, 1, pumpInfo);

      ['hose', 'coupling'].forEach(function (r) {
        if (vald[r]) html += rad(r, vald[r], antalKretsar,
          antalKretsar > 1 ? '<span class="bva-meta">Dubbelverkande cylinder kräver två ledningar</span>' : '');
      });
      ['gauge', 'gauge_adapter', 'oil'].forEach(function (r) {
        if (vald[r]) html += rad(r, vald[r], 1, '<span class="bva-meta">Rekommenderas</span>');
      });
      lista.innerHTML = html;

      var poster = [];
      Object.keys(vald).forEach(function (r) {
        if (!pa[r]) return;
        var n = (r === 'hose' || r === 'coupling') ? antalKretsar : 1;
        poster.push({ role: r, product: vald[r], qty: n });
      });
      poster.push({ role: 'cylinder', product: cylinder, qty: 1 });

      var summa = window.BVACompat.kitTotal(poster);
      // The discount line only shows where the store really grants it
      var rabatt = (rot.getAttribute('data-bva-rabatt') === 'true' && window.BVACompat.qualifiesForBundle(poster))
        ? Math.round(summa * window.BVACompat.BUNDLE_RATE) : 0;
      rot.querySelector('[data-bva-antal]').textContent = '(' + poster.length + ' artiklar, cylindern inräknad)';
      rot.querySelector('[data-bva-total]').innerHTML = kr(summa) +
        (rabatt ? ' <span class="bva-rabatt">− ' + kr(rabatt) + '</span>' : '');
    }

    lista.addEventListener('change', function (e) {
      var t = e.target.getAttribute('data-bva-toggle');
      if (t) { pa[t] = e.target.checked; rita(); return; }
      if (e.target.hasAttribute('data-bva-pumpval')) {
        var h = e.target.value;
        vald.pump = passande.filter(function (p) { return p.handle === h; })[0] || vald.pump;
        spara('bva_pump_bytt', { produkt: vald.pump.handle, sida: cylinder.handle });
        rita();
      }
    });

    rot.querySelector('[data-bva-add]').addEventListener('click', function () {
      var knapp = this;
      var items = [{ id: cylinder.variant_id, quantity: 1 }];
      Object.keys(vald).forEach(function (r) {
        if (!pa[r] || !vald[r].variant_id) return;
        items.push({ id: vald[r].variant_id, quantity: (r === 'hose' || r === 'coupling') ? antalKretsar : 1 });
      });
      knapp.disabled = true;
      knapp.textContent = 'Lägger till …';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        spara('bva_set_tillagt', { kalla: 'produktsida', artiklar: items.length, produkt: cylinder.handle });
        knapp.textContent = 'Tillagt i varukorgen ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { window.location.href = '/cart'; }, 700);
      }).catch(function () {
        knapp.disabled = false;
        knapp.textContent = 'Kunde inte lägga till — försök igen';
      });
    });

    rita();
  }

  function start() {
    document.querySelectorAll('[data-bva-set]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
